import { NgModule } from '@angular/core';
import { HOME_REPOSITORY } from '../application/token/home.token';
import { HomeRepository } from './repository/http/home.repository';
import { SLIDESHOW_REPOSITORY } from '../application/token/slideshow.token';
import { SlideshowRepository } from './repository/http/slideshow.repository';

@NgModule({
  providers: [
    {
      provide: HOME_REPOSITORY,
      useClass: HomeRepository,
    },
    {
      provide: SLIDESHOW_REPOSITORY,
      useClass: SlideshowRepository,
    },
  ],
})
export class HomeInfructureLayerModule {}
